/*
 * @Description:
 * @Author: dingxuejin
 * @Date: 2021-02-06 21:39:04
 * @LastEditTime: 2021-02-08 15:43:28
 * @LastEditors: dingxuejin
 */
(function (win, doc) {
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        html,
        htmlW,
        fontSize,
        rem,
        recalc = function () {
            html = doc.documentElement
            htmlW = html.clientWidth < 750 ? html.clientWidth : 750 //最大 1rem = 100px;
            fontSize = htmlW / 7.5  // 默认按照 IPhone 6 ,1rem = 50px;
            rem = doc.getElementById('rem') || null
            if (rem) {
                rem.parentNode.removeChild(rem)
            }
            /* 创建style标签并添加到Head标签里去 */
            var style = doc.createElement('style');
            style.id = 'rem';
            style.type = 'text/css';
            style.innerHTML = "html{font-size:" + fontSize + "px;}";
            doc.getElementsByTagName('HEAD').item(0).appendChild(style);
        }
    if (!doc.addEventListener) {
        return;
    }
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(window, document)